<div class="carousel-block">
    <!-- Carousel Content -->
    <div class="carousel-content">
        <div class="carousel-slides">
            <div *ngFor="let slide of carouselSlides; let i = index" class="carousel-slide" [style.background-image]="'url(' + slide.img + ')'" [class.active]="i === currentSlideIndex">
                <div class="home-block-1">
                    <div class="block-content">
                        <div class="title-section">
                            <h1 class="main-title"><img src="assets/images/title-plus.png" alt="Plus icon" class="title-icon">{{ slide.title }}</h1>
                            <p class="subtitle">{{ slide.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Footer with Navigation and Social Icons -->
    <div class="slider-footer">
        <div class="footer-content">
            <!-- Carousel Navigation -->
            <div class="carousel-nav">
                <!-- Previous Button -->
                <button class="nav-button" (click)="previousSlide()">
                    <img src="assets/images/icons/arrow-left.png" alt="Previous slide">
                </button>

                <!-- Navigation Dots -->
                <div class="nav-dots">
                    <button *ngFor="let slide of carouselSlides; let i = index" class="dot" [class.active]="i === currentSlideIndex" (click)="goToSlide(i)" [attr.aria-label]="'Go to slide ' + (i + 1)">
                    </button>
                </div>

                <!-- Next Button -->
                <button class="nav-button" (click)="nextSlide()">
                    <img src="assets/images/icons/arrow-right.png" alt="Next slide">
                </button>
            </div>

            <!-- Social Icons -->
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>
    </div>
</div>